import React from 'react';

const SuperAdminDashboard = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Super Admin Dashboard</h1>
      <p>Welcome to the Super Admin Dashboard. Full implementation coming soon...</p>
    </div>
  );
};

export default SuperAdminDashboard;
